module.exports = __webpack_public_path__ + "img/encuesta-de-satisfaccion.1e1a6989.svg";